import { RiskLevel } from "@/model/RiskLevel";
import { DefaultLower, NullBanner } from "@/model/DefaultBanners";
import WestSussexLogo from "@/assets/regions/west-sussex-wellbeing.png";
const IncreasingRisk = {
    rawCopy: `For Increasing Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online DrinkCoach Appointment</u>.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/11"
};
const HigherRisk = {
    rawCopy: `For Higher Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online DrinkCoach Appointment</u>.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/11"
};
const HighRisk = {
    rawCopy: `For High Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online DrinkCoach Appointment</u>.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/11"
};
export default {
    name: "West Sussex",
    logo: {
        file: WestSussexLogo,
        width: 250,
        height: 140
    },
    hasFreeAppointments: true,
    zoomLevel: 9,
    showServiceInfoOnResultsSummaryPage: true,
    synonyms: ["North Chailey"],
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: IncreasingRisk,
        [RiskLevel.Higher]: HigherRisk,
        [RiskLevel.High]: HighRisk
    },
    regions: [
        "Adur",
        "Arun",
        "Chichester",
        "Crawley",
        "Horsham",
        "Mid Sussex",
        "Worthing"
    ],
    clinics: [
        {
            name: "Drug and Alcohol Wellbeing Network (DAWN)",
            description: "Contact ${name}",
            tagline: "For those aged 25 and over",
            isPrimaryProvider: true,
            phone: ["0300 303 8677"],
            email: "WestSussex.contact@cgl.org.uk",
            showAtRiskLevel: [RiskLevel.High],
            website: "https://www.westsussexwellbeing.org.uk/topics/alcohol/support-available"
        },
        {
            name: "West Sussex Wellbeing Hubs have dedicated alcohol advisors located in each district. Contact the Wellbeing teams on the numbers below:",
            isPrimaryProvider: true,
            showAtRiskLevel: [RiskLevel.Higher],
            description: "hide",
            tagline: "<ul>" +
                "<li>Adur & Worthing: 01903 221450</li>" +
                "<li>Arun: 01903 737862</li>" +
                "<li>Chichester: 01243 521041</li>" +
                "<li>Crawley: 01293 585 317</li>" +
                "<li>Horsham: 01403 215111</li>" +
                "<li>Mid Sussex: 01444 477191</li>" +
                "</ul>"
        },
        {
            name: "DrinkCoach Online Appointment",
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher, RiskLevel.High],
            alwaysShowFirst: true,
            isPrimaryProvider: true,
            tagline: "Free coaching sessions are available for adults aged 18+ in West Sussex. " +
                "Daytime, evening and weekend appointments available. " +
                "<a href='https://drinkcoach.bookinglive.com/book/add/p/11' target='_blank'>Click here</a> to book an appointment.",
            alwaysShowInResults: true,
            website: "https://drinkcoach.bookinglive.com/book/add/p/11"
        },
        {
            name: "Carers Support West Sussex: Families and Friends Network",
            description: "Contact ${name}",
            showAtRiskLevel: [RiskLevel.Higher],
            tagline: "All services are confidential, and you can receive free information, advice and support.",
            isPrimaryProvider: true,
            phone: ["0300 028 8888"],
            website: "https://www.westsussexwellbeing.org.uk/topics/alcohol/support-for-family-friends"
        },
        {
            name: "Drug and Alcohol Wellbeing Network (DAWN)",
            description: "Contact ${name}",
            tagline: "For those aged 24 and under",
            isPrimaryProvider: true,
            phone: [
                "0300 303 8677",
                {
                    value: "0777 933 9954",
                    title: "Text (someone will ring you back):"
                }
            ],
            email: "wsypsms@cgl.org.uk",
            showAtRiskLevel: [RiskLevel.High],
            website: "https://www.westsussexwellbeing.org.uk/topics/alcohol/support-available"
        },
        {
            name: "West Sussex Drug and Alcohol Wellbeing Network",
            location: { lat: 51.1180413, lng: -0.1841805 },
            tagline: "North - Crawley, Horsham, Mid-Sussex",
            address: "Centenary house, Woodfield Road, Northgate, Crawley RH10 8GN",
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    info: "We are a flexible service and can support you outside these hours when needed. " +
                        "Ask us about our Saturday and evening options.",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                        saturday: [{ start: 1000, end: 1400 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.High],
            phone: ["0300 303 8677"],
            website: "https://www.changegrowlive.org/content/" +
                "drug-alcohol-wellbeing-network-north-team-crawley-horsham-mid-sussex"
        },
        {
            name: "West Sussex Drug and Alcohol Wellbeing Network",
            tagline: "Coastal - Adur, Littlehampton, Shoreham, Worthing",
            address: "1st Floor, Emel House, 30-32 Teville Road, Worthing BN11 1UG",
            location: { lat: 50.8173892, lng: -0.3754666 },
            showAtRiskLevel: [RiskLevel.High],
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    info: "We are a flexible service and can support you outside these hours when needed. " +
                        "Ask us about our Saturday and evening options.",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                        saturday: [{ start: 1000, end: 1400 }]
                    }
                }
            ],
            phone: ["0300 303 8677"],
            website: "https://www.changegrowlive.org/content/" +
                "drug-alcohol-wellbeing-network-coast-adur-littlehampton-shoreham-worthing"
        },
        {
            name: "West Sussex Drug and Alcohol Wellbeing Network",
            location: { lat: 50.7811264, lng: -0.6817057 },
            tagline: "West - Bognor Regis, Littlehampton",
            address: "14 Aldwick Road, Bognor Regis, PO21 2LJ",
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    info: "We are a flexible service and can support you outside these hours when needed. " +
                        "Ask us about our Saturday and evening options.",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                        saturday: [{ start: 1000, end: 1400 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.High],
            phone: ["0300 303 8677"],
            website: "https://www.changegrowlive.org/content/" +
                "drug-alcohol-wellbeing-network-west-bognor-regis-chichester-littlehampton"
        },
        {
            name: "West Sussex Drug and Alcohol Wellbeing Network",
            location: { lat: 50.8350063, lng: -0.7814498 },
            tagline: "West - Chichester",
            address: "The Old Post Office, Old Post Office Mews, South Pallant, Chichester, PO19 1XP",
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    info: "We are a flexible service and can support you outside these hours when needed. " +
                        "Ask us about our Saturday and evening options.",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                        saturday: [{ start: 1000, end: 1400 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.High],
            phone: ["0300 303 8677"],
            website: "https://www.changegrowlive.org/content/" +
                "drug-alcohol-wellbeing-network-west-bognor-regis-chichester-littlehampton"
        },
        {
            name: "West Sussex Children and Young People's Drug and Alcohol Wellbeing Service",
            tagline: "Under 25 years old",
            address: "Emel House, 30-32 Teville Road, Worthing BN11 1UG",
            location: { lat: 50.8173892, lng: -0.3754666 },
            description: "Young people are offered appointments at a venue which suits them and " +
                "drop-ins are held around the county, including FindItOut Centres.",
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    info: "We are a flexible service and can support you outside these hours when needed.",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.High],
            phone: ["0300 303 8677", "07779339954"],
            website: "https://www.changegrowlive.org/young-people/" +
                "west-sussex-children-young-people-drug-alcohol-wellbeing-service"
        },
        {
            name: "Adur & Worthing Wellbeing",
            description: "Our Alcohol Wellbeing Advisors are available across West Sussex. " +
                "They provide one-to-one support to help you cut down or stop drinking. " +
                "Currently this service is being offered by telephone, video calling and text. " +
                "Contact us on the details below:",
            address: "Worthing Town Hall, Chapel Road, Worthing, West Sussex, BN11 1HA",
            location: { lat: 50.8145676, lng: -0.3746592 },
            times: [
                {
                    title: "Opening times: By appointment only",
                }
            ],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            phone: ["01903 221450"],
            website: "https://adur-worthing.westsussexwellbeing.org.uk/",
            referral: "https://www.adur-worthing.gov.uk/eforms/aws-ext-wellbeing-referral.ofml"
        },
        {
            name: "Arun Wellbeing - Littlehampton",
            description: "Our Alcohol Wellbeing Advisors are available across West Sussex. " +
                "They provide one-to-one support to help you cut down or stop drinking. " +
                "Currently this service is being offered by telephone, video calling and text. " +
                "Contact us on the details below:",
            address: "Arun Civic Centre, Maltravers Road, Littlehampton, BN17 5LF",
            location: { lat: 50.8126294, lng: -0.5149003 },
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            phone: ["01903 737862"],
            website: "https://arun.westsussexwellbeing.org.uk/",
            referral: "https://www1.arun.gov.uk/external/Wellbeing_SelfReferralForm.ofml"
        },
        {
            name: "Arun Wellbeing - Bognor Regis",
            description: "Our Alcohol Wellbeing Advisors are available across West Sussex. " +
                "They provide one-to-one support to help you cut down or stop drinking. " +
                "Currently this service is being offered by telephone, video calling and text. " +
                "Contact us on the details below:",
            address: "Wellbeing Annexe, Bognor Town Hall, Clarence Road, Bognor Regis, PO21 1LD",
            location: { lat: 50.8128044, lng: -0.5149003 },
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            phone: ["01903 737862"],
            website: "https://arun.westsussexwellbeing.org.uk/",
            referral: "https://www1.arun.gov.uk/external/Wellbeing_SelfReferralForm.ofml"
        },
        {
            name: "Chichester Wellbeing",
            description: "Our Alcohol Wellbeing Advisors are available across West Sussex. " +
                "They provide one-to-one support to help you cut down or stop drinking. " +
                "Currently this service is being offered by telephone, video calling and text. " +
                "Contact us on the details below:",
            address: "Westgate Leisure Chichester, Via Ravenna, Chichester, PO19 1RJ",
            location: { lat: 50.8329561, lng: -0.7890151 },
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 845, end: 1700 }],
                        tuesday: [{ start: 845, end: 1700 }],
                        wednesday: [{ start: 845, end: 1700 }],
                        thursday: [{ start: 845, end: 1700 }],
                        friday: [{ start: 845, end: 1710 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            phone: ["01243 521041"],
            website: "https://chichester.westsussexwellbeing.org.uk/",
            referral: "https://eforms.chichester.gov.uk/officeforms/wellbeing-referral-form.ofml",
        },
        {
            name: "Crawley Wellbeing",
            description: "Our Alcohol Wellbeing Advisors are available across West Sussex. " +
                "They provide one-to-one support to help you cut down or stop drinking. " +
                "Currently this service is being offered by telephone, video calling and text. " +
                "Contact us on the details below:",
            address: "K2 Crawley, Pease Pottage Hill, Crawley, RH11 9BQ",
            location: { lat: 51.0969359, lng: -0.1934499 },
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            phone: ["01293 585 317"],
            referral: "https://my.crawley.gov.uk/service/wellbeing_enquiry",
            website: "https://crawley.westsussexwellbeing.org.uk/"
        },
        {
            name: "Horsham Wellbeing",
            description: "Our Alcohol Wellbeing Advisors are available across West Sussex. " +
                "They provide one-to-one support to help you cut down or stop drinking. " +
                "Currently this service is being offered by telephone, video calling and text. " +
                "Contact us on the details below:",
            address: "Horsham District Council, Parkside, Chart Way, Horsham, West Sussex, RH12 1RL",
            location: { lat: 51.0639046, lng: -0.3267348 },
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            phone: ["01403 215111"],
            referral: "https://digital.horsham.gov.uk/outreach/LEI_WellbeingReferral.ofml",
            website: "https://horsham.westsussexwellbeing.org.uk/"
        },
        {
            name: "Mid Sussex Wellbeing",
            description: "Our Alcohol Wellbeing Advisors are available across West Sussex. " +
                "They provide one-to-one support to help you cut down or stop drinking. " +
                "Currently this service is being offered by telephone, video calling and text. " +
                "Contact us on the details below:",
            address: "Mid Sussex District Council, Oaklands Road, Haywards Heath, RH16 1SS",
            location: { lat: 51.0017796, lng: -0.1113779 },
            times: [
                {
                    title: "Opening times (appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1600 }]
                    }
                }
            ],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher],
            phone: ["01444 477191"],
            website: "https://midsussex.westsussexwellbeing.org.uk/",
            referral: "https://forms.midsussex.gov.uk/form-36291/wellbeing-referral"
        }
    ]
};
//# sourceMappingURL=WestSussex.js.map